<template>
  <modal
    name="edit-permit"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="620"
    height="auto"
    @before-open="getData"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Edit Permit</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--ss txt--off-white mb-2"
              >Permit name (required)</label
            >
            <input
              type="text"
              class="textInputField"
              placeholder="Enter a permit name"
              v-model.trim="permit.permit_name"
            />
          </div>
          <div class="form-group">
            <!-- <label class="txt--xs txt--off-white">
              Permit price (required)
            </label> -->
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
                mb-2
              "
            >
              <p class="txt--xs txt--off-white">
                Permit price (required)
              </p>
              <span v-if="this.permit.permit_price != this.old_permit_price">
                <app-toggle
                  label="Notify Users" 
                  :checked="permit.notify_users"
                  @update:checked="getCheckedStatus($event, 'notify_users')"
                ></app-toggle>
              </span>
            </div>
            <div class="input-group-prfix">
              <span class="input-group-prefix-text">$</span
              ><input
                type="text"
                placeholder="Enter permit price"
                class="textInputField"
                v-model.number="permit.permit_price"
                @keypress="checkFloat"
              />
            </div>
          </div>

          <div class="form-group">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
                mb-2
              "
            >
              <p class="txt--xs txt--off-white">Property (required)</p>
              <!-- <app-toggle label="All properties" :checked="false"> </app-toggle> -->
            </div>
            <model-list-select
                :list="propertyLists.filter(property => !this.permit.property_id_list.includes(property.space_id))"
                v-model="permit.property_id"
                option-value="space_id"
                option-text="property_name"
                placeholder="Select property"
                class="custom-vue-select"
                :isDisabled="permit.handle_method !== true"
              @input="onPermitPropertyChange"
            >
            </model-list-select>
          </div>
          <div class="form-group">
              <div
              class="
                  d-flex
                  align-items-center
                  justify-content-between
                  flex-wrap
                  mb-2
              "
              >
                <p class="txt--xs txt--off-white">Additional properties (optional)
                    <i
                        class="ml-2 far fa-question-circle"
                        v-tooltip="'Allow permit to be used in multiple properties'">
                    </i>
                </p>
                <!-- <app-toggle label="All properties" :checked="false"> </app-toggle> -->
              </div>
              <multi-list-select
                  :list="propertyLists.filter(property => property.space_id !== permit.property_id)"
                  option-value="space_id"
                  option-text="property_name"
                  :selected-items="additionalProperties"
                  placeholder="Select additional properties"
                  @select="didSelectAdditionalProperties"
                  class="custom-vue-select"
              >
              </multi-list-select>
          </div>
          <div class="form-group">
            <label class="txt--xs txt--off-white mb-2">Required custom identifiers</label>
            <multi-list-select
              :list="requiredCustomIdentifierOptions"
              option-value="value"
              option-text="text"
              :selected-items="selectedRequiredCustomIdentifiers"
              placeholder="Select required identifier keys"
              @select="selectRequiredCustomIdentifiers"
              class="custom-vue-select"
              :isDisabled="requiredCustomIdentifiersLoading"
            >
            </multi-list-select>
            <p v-if="requiredCustomIdentifiersLoading" class="txt--xs txt--off-white opacity--50 mt-2 mb-0">
              Loading available custom identifier keys...
            </p>
            <p v-else-if="!permit.property_id" class="txt--xs txt--off-white opacity--50 mt-2 mb-0">
              Showing owner-level shared keys. Select a property to include property-specific keys.
            </p>
            <p v-else class="txt--xs txt--off-white opacity--50 mt-2 mb-0">
              Showing owner-level shared keys plus keys specific to this permit's property.
            </p>
            <p v-if="requiredCustomIdentifiersError" class="txt--xs txt--red mt-2 mb-0">
              {{ requiredCustomIdentifiersError }}
            </p>
          </div>
          <div class="form-group">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
                mb-2
              "
            >
              <p class="txt--xs txt--off-white">
                Number of permits available (required)
              </p>

              <app-toggle label="Unlimited" :checked="permit.unlimited_permit" @update:checked="getCheckedStatus($event, 'unlimited_permit')"> </app-toggle>
            </div>
            <input
              type="text"
              class="textInputField"
              placeholder="Enter permit quantity"
              :key="permit_quantity_key"
              :disabled="permit.unlimited_permit"
              v-model.number="permit.permit_quantity"
              @keypress="checkNumber"
            />
          </div>
          <div class="form-group">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
                mb-2
              "
            >
              <p class="txt--xs txt--off-white">
                Enforce vehicle count
              </p>

              <app-toggle
                :checked="permit.enforce_vehicle_count"
                :label="'Enforced'"
                @update:checked="getCheckedStatus($event, 'enforce_vehicle_count')"
              ></app-toggle>
            </div>
            <div v-if="permit.enforce_vehicle_count">
              <label class="txt--xs txt--off-white mb-2">Allowed vehicles</label>
              <input
                type="number"
                min="1"
                class="textInputField"
                placeholder="Enter allowed vehicles"
                v-model.number="permit.enforced_vehicle_count"
                @input="enforcedVehicleCountError = ''"
              />
            </div>
            <p v-if="enforcedVehicleCountError" class="txt--xs txt--red mt-2 mb-0">
              {{ enforcedVehicleCountError }}
            </p>
          </div>

          <div class="form-group">
            <label class="txt--xs txt--off-white mr-2">Permit Types</label>
            <ul class="top__filter__ul top__filter__ul--btn">
              <li :class="[permit.recurring == 0  &&  flex_permit_onetime == false && permit.flex_permit != 1? 'active' : '']">One-Time Permit</li>
              
              <!-- <li :class="[permit.recurring == 0 ?'active' : '']">One-Time Permit</li> -->
              <li :class="[permit.recurring == 1 && permit.flex_permit!=1 ? 'active' : '']">Recurring Permit</li>
              <li :class="[permit.recurring == 1 && permit.flex_permit == 1  || permit.recurring== 0 && permit.flex_permit == 1? 'active' : '']">Flex Permit</li>
            </ul>
          </div>

          <div class="form-group" v-if="permit.recurring == 0 &&  permit.flex_permit != 1">
            <label class="txt--xs txt--off-white mb-2 mr-2">Permit term</label>
            <ul class="top__filter__ul top__filter__ul--btn">
              <li :class="[permit.date_range == 1 ? 'active' : '']">Start & End Date</li>
              <li :class="[permit.date_range == 0 ? 'active' : '']">Duration</li>
            </ul>
          </div>
          <div class="form-row" v-if="permit.recurring == 0  &&  permit.flex_permit != 1">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="txt--xs txt--off-white mb-2 mr-2"
                  >Start Date</label
                >
                <VueDateTime
                  title="Start Date"
                  type="datetime"
                  input-id="start_date"
                  class="dateTime__picker"
                  format="yyyy-MM-dd hh:mm a"
                  :input-class="['textInputField']"
                  :min-datetime="minDatetime"
                  :max-datetime="permit.end_date"
                  v-tooltip="permitTimeZone"
                  v-model="permit.start_date"
                  :zone="permitTimeZone"
                  :clear-button="true"
                  :disabled="true"
                ></VueDateTime>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="txt--xs txt--off-white mb-2 mr-2"
                  >End Date</label
                >
                <VueDateTime
                  title="End Date"
                  type="datetime"
                  input-id="end_date"
                  class="dateTime__picker"
                  format="yyyy-MM-dd hh:mm a"
                  :input-class="['textInputField']"
                  :min-datetime="permit.start_date"
                  v-tooltip="permitTimeZone"
                  v-model="permit.end_date"
                  :zone="permitTimeZone"
                  :clear-button="true"
                  :disabled="true"
                ></VueDateTime>
              </div>
            </div>
          </div>
          <div class="form-row" v-if="(permit.recurring == 0 && permit.date_range == 0) || permit.recurring ==1">
            <div class="col-sm-6">
                <div class="form-group">
                  <label class="txt--xs txt--off-white mb-2"
                      >Permit Duration</label
                  >
                  <input
                    type="text"
                    @keypress="checkNumber()"
                    placeholder="Duration"
                    disabled
                    readonly
                    class="textInputField"
                    v-model.number="permit.permit_duration"
                  />
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                  <label class="txt--xs txt--off-white mb-2"
                  >Permit Duration Type</label
                  >
                  <model-select 
                    :options="duration_options"
                    class="custom-vue-select"
                    v-model="permit.permit_duration_type"
                    placeholder="Select Duration Type"
                    :isDisabled="true"
                  >
                  </model-select>
                </div>
            </div>
          </div>
          <div v-if="permit.flex_permit == 1" class="form-group">
            <label for="" class="txt--xs txt--off-white mb-2">Number of available parking days</label>
            <input type="text" name="no_available_parking_days" id="available_parking_days" class="textInputField" @keypress="checkNumber" v-model="permit.available_parking_days">
          </div>
          <div class="form-group" v-if="permit.recurring != 0 || permit.flex_permit == 1">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
                mb-2
              "
            >
              <p class="txt--xs txt--off-white">
                Require backdate on assignment
              </p>

              <app-toggle
                :checked="permit.backdate_subscription"
                :label="'Required'"
                @update:checked="getCheckedStatus($event, 'backdate_subscription')"
              ></app-toggle>
            </div>
            <div v-if="permit.backdate_subscription" class="mt-2">
              <label class="txt--xs txt--off-white mb-2">Start date template</label>
              <input
                type="text"
                class="textInputField"
                placeholder="Y-m-01 00:00:00"
                v-model.trim="permit.backdate_start_date_template"
                @input="backdateTemplateError = ''"
              />
              <p class="txt--xs txt--off-white opacity--50 mt-2 mb-1">
                <strong>Format examples:</strong>
              </p>
              <ul class="txt--xs txt--off-white opacity--50 ml-3 mb-2">
                <li><code>Y-m-d 00:00:00</code> = Today (2025-01-15 00:00:00)</li>
                <li><code>Y-m-01 00:00:00</code> = First of current month (2025-01-01 00:00:00)</li>
                <li><code>Y-01-01 00:00:00</code> = First of current year (2025-01-01 00:00:00)</li>
                <li><code>monday this week</code> = Start of current week</li>
              </ul>
            </div>
            <p v-if="backdateTemplateError" class="txt--xs txt--red mt-2 mb-0">
              {{ backdateTemplateError }}
            </p>
          </div>
          <div class="form-group">
           <!--  <label class="txt--xs txt--off-white mb-2 mr-2"
              >Days of the week</label
            > -->
            <div
            class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
                mb-2
            "
            >
                <p class="txt--xs txt--off-white">
                    Days of the week
                </p>
               <!-- ['+(test?'Active':'Inactive')+'] -->
               <!--   v-if="permit.flex_permit != 1" -->
                <app-toggle 
                :checked="permit.activate_permit_timeslot"
                :label="'TimeSlot['+(test?'Active':'Inactive')+']'"
                @update:checked="getCheckedStatus($event, 'activate_permit_timeslot')"> </app-toggle>
               
            </div>
            
            <ul class="top__filter__ul top__filter__ul--btn">
              <li :class="[permit.available_days.indexOf(7) !== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(7)">Sun</li>
              <li :class="[permit.available_days.indexOf(1) !== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(1)">Mon</li>
              <li :class="[permit.available_days.indexOf(2) !== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(2)">Tue</li>
              <li :class="[permit.available_days.indexOf(3) !== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(3)">Wed</li>
              <li :class="[permit.available_days.indexOf(4) !== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(4)">Thu</li>
              <li :class="[permit.available_days.indexOf(5) !== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(5)">Fri</li>
              <li :class="[permit.available_days.indexOf(6) !== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(6)">Sat</li>
              <li :class="[allDays ? 'active' : '']" style="cursor: pointer" @click="selectAlldays">All</li>
            </ul>
            
            <ul class="top__filter__ul mx-1" v-if="permit.activate_permit_timeslot==true">
                <li :class="[permit.available_days.indexOf(7)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(7)">View</li>
                <li :class="[permit.available_days.indexOf(1)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(1)">View</li>
                <li :class="[permit.available_days.indexOf(2)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(2)">View</li>
                <li :class="[permit.available_days.indexOf(3)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(3)">View</li>
                <li :class="[permit.available_days.indexOf(4)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(4)">View</li>
                <li :class="[permit.available_days.indexOf(5)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(5)">View</li>
                <li :class="[permit.available_days.indexOf(6)!== -1 ? 'active' : '']" class="mx-1" style="cursor: pointer" @click="viewDayTimeSlot(6)">View</li>
                <li :class="[allDays ? 'active' : '']" class="mx-1" style="cursor: pointer" @click="viewDayTimeSlot(8)">View</li>
            </ul>
          </div>

           <div class="" id="permit_time_div" v-if="displayTimeFlag==true && permit.activate_permit_timeslot==true">
                        
              <div class="form-row mb-4">
                  <div class="col-sm-8">
                      <p class="txt--primary txt--semi-bold txt--ss">{{this.selectedDay?this.selectedDay:'Sunday'}}'s Time Slots</p>
                  </div>

                  <div class="col-sm-3">
                      <a
                          href="javascript:void(0);"
                          class="txt--primary txt--ss float-right"
                          @click="
                          addPermitTime()
                          "
                      >
                          Add More(+)
                      </a>
                  </div>
              </div>
              <div class="form-row" v-for='(permitTime, index) in permitTimesCurrent'  :key="index">
                  <div class="col-sm-4">
                      <div class="form-group">
                          <label class="txt--xs txt--off-white mb-2 mr-2"
                          >Start Time (required)</label
                          >
                          <VueDateTime
                              title="Start Time"
                              type="time"
                              input-id="start_time"
                              class="dateTime__picker"
                              format="hh:mm a"
                              :input-class="['textInputField']"
                              :zone="permitTimeZone"
                              v-tooltip="permitTimeZone"
                              v-model="permitTime.permitStartTime"
                              :clear-button="true"
                              @close="checkDurationTime(permitTime)"
                          ></VueDateTime>
                      </div>
                  </div>
                  <div class="col-sm-4">
                      <div class="form-group">
                          <label class="txt--xs txt--off-white mb-2 mr-2"
                          >End Time (required)</label
                          >
                          <VueDateTime
                              title="End Time"
                              type="time"
                              input-id="end_time"
                              class="dateTime__picker"
                              format="hh:mm a"
                              :input-class="['textInputField']"
                              :zone="permitTimeZone"
                              v-tooltip="permitTimeZone"
                              v-model="permitTime.permitEndTime"
                              :clear-button="true"
                              @close="checkDurationTime(permitTime)"
                          ></VueDateTime>
                      </div>
                  </div>
                  <div class="col-sm-4">
                      <div class="mt-4 pt-2"
                      >
                          <a
                              v-if="permitTime.permitStartTime != '' || permitTime.permitEndTime != ''"
                              href="javascript:void(0);"
                              class="text-white txt--ss opacity--50"
                              @click="
                              permitTime.permitStartTime = '';
                              permitTime.permitEndTime = '';
                              "
                          >
                              Clear
                          </a>
                          <a
                              href="javascript:void(0);"
                              class="text-white txt--ss opacity--50 ml-4"
                              @click="
                              removePermitTime(index)
                              "
                          >
                              Remove
                          </a>
                      </div>
                      
                  </div>
              </div>
              
          </div>


          <div class="mb-4">
            <label class="txt--xs txt--off-white mb-2 mr-2">More options</label>
            <div class="mb-2" v-if="permit.flex_permit == 1">
                <app-toggle 
                    :checked="flex_permit_onetime"
                    :label="'One time'"
                    @update:checked="getCheckedStatus($event, 'onetime')"
                > 
                </app-toggle>
            </div>            
            <div class="mb-2">
              <app-toggle label="Free Permit" :checked="permit.free_permit" @update:checked="getCheckedStatus($event, 'freePermit')"> </app-toggle>
            </div>
            <div class="mb-2">
              <app-toggle label="Full access" :checked="permit.full_access" @update:checked="getCheckedStatus($event, 'full_access')"> </app-toggle>
            </div>
            <div class="mb-2">
              <app-toggle label="EV charging" :checked="permit.ev_charging" @update:checked="getCheckedStatus($event, 'ev_charging')"> </app-toggle>
            </div>
            <!-- <div class="mb-2">
              <app-toggle label="Allow multiple vehicles" :checked="false">
              </app-toggle>
            </div> -->
            <div class="mb-2">
              <app-toggle
                label="Manual payment method (not automated with Stripe)"
                :checked="permit.handle_method"
                @update:checked="getCheckedStatus($event, 'handle_method')"
                :disabled="true"
              >
              </app-toggle>
            </div>
            <div class="mb-2">
              <app-toggle
                :checked="permit.free_weekend_permit"
                :label="'Free Weekend Parking'"
                @update:checked="getCheckedStatus($event, 'freeWeekendPermit')"
              ></app-toggle>
            </div>
            <div class="mb-2">
              <app-toggle
                :checked="permit.public_permit"
                :label="'Public Permit'"
                @update:checked="getCheckedStatus($event, 'publicPermit')"
              ></app-toggle>
            </div>
          </div>
          <div class="form-group mb-4 d-none">
            <label class="txt--xs txt--off-white mb-2 mr-2"
              >Availability/Visibility</label
            >
            <ul class="top__filter__ul top__filter__ul--btn">
              <li class="active">Public (instant)</li>
              <li>Private (manual)</li>
            </ul>
            <p class="txt--xs txt--off-white">
              Permit appears available on the property’s public profile for
              instant purchase
            </p>
          </div>
          <div class="form__group mb-3">
            <label class="txt--xs txt--off-white mb-2"
              >Add other permit (Optional)</label>
            <multi-list-select
              :list="filtered_permit_list"
              option-value="permit_id"
              option-text="permit_name"
              :selected-items="subpermit_selected_list"
              @select="selectSubPermits"
              placeholder="Select sub permit(s)"
              class="custom-vue-select"
            />
          </div>
          <div v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)">
            <p class="txt--xs txt--off-white mb-2">
              Delete this permit
            </p>
            <div class="mb-1">
              <app-toggle
                :checked="permit.force_delete"
                :label="'Force'"
                v-tooltip="'Delete the active subscriptions under this permit'"
                @update:checked="getCheckedStatus($event, 'force_delete')"
              ></app-toggle>
            </div>
            <div class="mb-1">
              <app-toggle
                :checked="permit.notify_users"
                :label="'Notify'"
                v-tooltip="'Notify users with active subscriptions about the deletion'"
                @update:checked="getCheckedStatus($event, 'notify_users')"
              ></app-toggle>
            </div>
            <p class="txt--xs txt--red font-weight-bold cursor-pointer mt-2 mb-1" @click="deletePermit">Delete</p>
          </div>
        </div>
      </div>
      <div
        v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)"
      class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner
        class="button button--primary button--sm mr-3"
        :disabled="update_button.disabled"
        :loading="update_button.loading"
        :success="update_button.success"
        @click="updatePermit"
        >
        Update</ButtonWithSpinner
        ><button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect, ModelListSelect, MultiListSelect } from "vue-search-select";
import Toggle from "@/components/toggle";
import { Datetime as VueDateTime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import ButtonWithSpinner from "@/components/Button";
import {
  buildCustomIdentifierKeyOptions,
  buildSelectedCustomIdentifierKeys,
  extractApiErrorMessage,
  extractFieldErrors,
  fetchCustomIdentifierKeys,
  mergeCustomIdentifierKeyOptions,
  normalizeRequiredCustomIdentifierKey,
  normalizeRequiredCustomIdentifiers,
  parseRequiredCustomIdentifiers,
} from "@/services/customIdentifier.service";

const __getEmptyTimeSlots = () => {
    return [
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //mon index-0
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //tue index-1
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //wed index-2
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //thu index-3
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //fri index-4
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //sat index-5
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //sun index-6
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //all index-7                     
    ];
}

export default {
  name: "EditPermit",
  components: {
    ModelListSelect,
    ModelSelect,
    MultiListSelect,
    ButtonWithSpinner,
    AppToggle: Toggle,
    VueDateTime,
  },
  data() {
    return {
      minDatetime: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
      propertyLists: [],
      permit_quantity_key: 1,
      allDays:false,
      dayOfWeekArr: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday","Allday"],    
      selectedDay:'',
      displayTimeFlag:false,
      permitTimeZone: '',
      permitTimesCurrent: {}, 
      permit: {
        permit_name: '',
        permit_price: 0,
        property_id_list: [],
        unlimited_permit: false,
        permit_quantity: 0,
        recurring: 0,
        date_range: 1,
        start_date: '',
        end_date: '',
        duration: '',
        duration_type: 'month',
        available_days: [],
        permitTimes: __getEmptyTimeSlots(),
        activate_permit_timeslot:false, 
        full_access: false,
        ev_charging: false,
        free_permit:false,
        handle_method: false,
        flex_permit:0,
        available_parking_days: 1,
        free_weekend_permit: false,
        public_permit: false,
        enforce_vehicle_count: false,
        enforced_vehicle_count: null,
        backdate_subscription: false,
        backdate_start_date_template: '',
        sub_permit_ids:  [],
        notify_users: false,
        force_delete: false,
      },
      property_id: '',
      additionalProperties: [],
      flex_permit_onetime:false,
      duration_options: [
        {value: '', text: 'Select Duration Type'},
        {value: 'day', text: 'Day'},
        {value: 'week', text: 'Week'},
        {value: 'month', text: 'Month'},
        {value: 'year', text: 'Year'},
      ],
      update_button: {
        disabled: false,
        success: false,
        loading: false
      },
      user_role:    '',
      access_list:  {},
      permit_list:  [],
      filtered_permit_list:   [],
      test:false,
      old_permit_price: 0,
      subpermit_selected_list: [],
      requiredCustomIdentifierOptions: [],
      selectedRequiredCustomIdentifiers: [],
      requiredCustomIdentifiersLoading: false,
      requiredCustomIdentifiersError: '',
      backdateTemplateError: '',
      enforcedVehicleCountError: '',
    };
  },
  created() {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list"));
    this.getAllproperty();
    this.getAllPermits();
  },
  watch: {
    'permit.permit_duration_type': function(val) {
      if (this.permit.backdate_subscription) {
        const durationTemplates = {
          day: 'Y-m-d 00:00:00',
          week: 'monday this week',
          month: 'Y-m-01 00:00:00',
          year: 'Y-01-01 00:00:00'
        };
        this.permit.backdate_start_date_template = durationTemplates[val] || '';
      }
    }
  },
  methods: {
    selectSubPermits(items) {
      this.subpermit_selected_list = items;
    },
    normalizeRequiredCustomIdentifierKey(value) {
      return normalizeRequiredCustomIdentifierKey(value);
    },
    normalizeRequiredCustomIdentifiers(rawIdentifiers) {
      return normalizeRequiredCustomIdentifiers(rawIdentifiers);
    },
    getNormalizedRequiredCustomIdentifiersFromPermit(rawIdentifiers) {
      return parseRequiredCustomIdentifiers(rawIdentifiers);
    },
    buildRequiredCustomIdentifierSelection(keys) {
      return buildSelectedCustomIdentifierKeys(keys);
    },
    mergeRequiredCustomIdentifierOptions(options, selectedKeys) {
      return mergeCustomIdentifierKeyOptions(options, selectedKeys);
    },
    setSelectedRequiredCustomIdentifiersFromKeys(keys) {
      this.selectedRequiredCustomIdentifiers = this.buildRequiredCustomIdentifierSelection(keys);
    },
    getRequiredCustomIdentifierOptionsFromResponse(keys) {
      return buildCustomIdentifierKeyOptions(keys);
    },
    async fetchRequiredCustomIdentifierOptions(propertyId, preserveUnknownSelections = false) {
      const normalizedPropertyId = this.normalizeRequiredCustomIdentifierKey(propertyId);
      const selectedKeys = this.getRequiredCustomIdentifiersPayload();

      this.requiredCustomIdentifiersLoading = true;
      this.requiredCustomIdentifiersError = '';

      try {
        const keys = await fetchCustomIdentifierKeys(this.axios, window.hostname, normalizedPropertyId);
        const baseOptions = this.getRequiredCustomIdentifierOptionsFromResponse(keys);
        const nextOptions = preserveUnknownSelections
          ? this.mergeRequiredCustomIdentifierOptions(baseOptions, selectedKeys)
          : baseOptions;
        const availableKeys = nextOptions.map((option) => this.normalizeRequiredCustomIdentifierKey(option.value));
        const nextSelectedKeys = preserveUnknownSelections
          ? selectedKeys
          : selectedKeys.filter((key) => availableKeys.includes(key));

        this.requiredCustomIdentifierOptions = nextOptions;
        this.setSelectedRequiredCustomIdentifiersFromKeys(nextSelectedKeys);
      } catch (error) {
        this.requiredCustomIdentifierOptions = preserveUnknownSelections
          ? this.mergeRequiredCustomIdentifierOptions([], selectedKeys)
          : [];
        this.setSelectedRequiredCustomIdentifiersFromKeys(preserveUnknownSelections ? selectedKeys : []);
      } finally {
        this.requiredCustomIdentifiersLoading = false;
      }
    },
    selectRequiredCustomIdentifiers(items) {
      this.selectedRequiredCustomIdentifiers = Array.isArray(items) ? items : [];
      this.requiredCustomIdentifiersError = '';
    },
    getRequiredCustomIdentifiersPayload() {
      return this.normalizeRequiredCustomIdentifiers(this.selectedRequiredCustomIdentifiers);
    },
    validateRequiredCustomIdentifiers() {
      const requiredCustomIdentifiers = this.getRequiredCustomIdentifiersPayload();

      for (const identifierKey of requiredCustomIdentifiers) {
        if (identifierKey.length > 64) {
          return {
            valid: false,
            message: `Required custom identifier keys cannot exceed 64 characters: ${identifierKey}`,
          };
        }
      }

      return { valid: true };
    },
    getEmptyTimeSlots() {
      return __getEmptyTimeSlots();
    },
    getAllproperty() {
      this.axios
        .post(window.hostname + "/api/auth/all-space", {
          device_type: 1,
          limit: 100,
          page: 1,
          search_param: "",
          space_type: 1,
          status: 4,
          minify: 1,
          minify_2: 1,
        })
        .then((res) => {
          if (res.data.status) {
            this.propertyLists = res.data.data.all_space;
            this.setSelectedAdditionalProperties();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllPermits()
    {
      this.axios
        .post(window.hostname + "/api/auth/permit/list", {
          commercial: 1,
          page: 1,
          limit: 500,
          all: 1,
          // property_id: this.property_id,
        })
        .then((res) => {
          if (res.data.status) {
            this.permit_list = res.data.data.permit_list ? res.data.data.permit_list : [];
          } else {
            this.permit_list = [];
          }
          if(this.permit_list.length == 0) { this.button.disabled=true; }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getCurrentPermitTimezone() {
      return this.propertyLists.filter((property) => {
        return this.permit.property_id == property.space_id;
      }).map((property) => {
        return property['time_zone'];
      })[0];
    },
    onPermitPropertyChange(propertyId) {
      this.permit.property_id = propertyId;
      this.permitTimeZone = this.getCurrentPermitTimezone();
      this.requiredCustomIdentifiersError = '';
      this.fetchRequiredCustomIdentifierOptions(propertyId);
    },
    getData(e) {
      this.permit = e.params.permit;
      this.property_id = this.permit.property_id;
      this.setSelectedRequiredCustomIdentifiersFromKeys(
        this.getNormalizedRequiredCustomIdentifiersFromPermit(
          this.permit.required_custom_identifiers || this.permit.required_custom_idenitifers || []
        )
      );

      this.subpermit_selected_list = this.permit.attached_permit_details.map(permit => {
        return {
          'permit_id': permit._id,
          'permit_name': permit.name
        };
      });
      
      if (Array.isArray(this.permit.property_id_list) === false) {
        this.permit.property_id_list = [];
      }

      this.old_permit_price = this.permit.permit_price;
      this.permit.unlimited_permit = e.params.permit.quantity_unlimited=== 1 ? true : false; 
      this.permit.free_permit = e.params.permit.free_permit=== 1 ? true : false; 
      this.permit.full_access = e.params.permit.full_access === 1 ? true : false;
      this.permit.handle_method = e.params.permit.handle_method === "manual" ? true : false;
      this.permit.ev_charging = e.params.permit.ev_charging === 1 ? true : false;
      this.permit.free_weekend_permit = e.params.permit.free_weekend_permit ===1? true : false;
      this.permit.public_permit = e.params.permit.public_permit ===1? true : false;
      this.permit.enforce_vehicle_count = e.params.permit.enforce_vehicle_count === true || e.params.permit.enforce_vehicle_count === 1 || e.params.permit.enforce_vehicle_count === '1' || e.params.permit.enforce_vehicle_count === 'true';
      this.permit.enforced_vehicle_count = e.params.permit.enforced_vehicle_count ? parseInt(e.params.permit.enforced_vehicle_count, 10) : null;
      this.permit.backdate_subscription = e.params.permit.backdate_subscription === true || e.params.permit.backdate_subscription === 1 || e.params.permit.backdate_subscription === '1' || e.params.permit.backdate_subscription === 'true';
      this.permit.backdate_start_date_template = e.params.permit.backdate_start_date_template || '';
      this.permit.permit_duration_type =  e.params.permit.permit_duration_type;
      this.permit.activate_permit_timeslot = e.params.permit.available_days_timeslot_status ===1? true : false;
      this.permitTimeZone = this.getCurrentPermitTimezone();
      this.backdateTemplateError = '';
      this.enforcedVehicleCountError = '';

      if (this.permit.activate_permit_timeslot == true) {
          this.permit.permitTimes = e.params.permit.available_days_timeslot.map(timeslot => {
              return timeslot
              .filter(time => time.permitStartTime !== null && time.permitEndTime !== null)
              .map(time => {
                  return {
                      permitStartTime: this.$moment(time.permitStartTime).tz(this.permitTimeZone).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
                      permitEndTime: this.$moment(time.permitEndTime).tz(this.permitTimeZone).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
                      permitFormatedStartTime: this.$moment(time.permitStartTime).tz(this.permitTimeZone).format("HH:mm"),
                      permitFormatedEndTime: this.$moment(time.permitEndTime).tz(this.permitTimeZone).format("HH:mm"),
                  }
              });

          })
      } else {
          this.permit.permitTimes = this.getEmptyTimeSlots();
      }

      if(e.params.permit.available_days.length < 7){
        this.allDays=false;
      }
      else if(e.params.permit.available_days.length == 7){
        this.allDays=true;
      }

      if(this.permit.start_date != '' && this.permit.end_date!='') {
        this.permit.start_date = this.$moment(this.permit.start_date).tz(this.permitTimeZone).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        this.permit.end_date = this.$moment(this.permit.end_date).tz(this.permitTimeZone).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        this.permit.date_range = 1;
      }
      else {
        this.permit.date_range = 0;
      }


      let filteredList = this.permit_list;
      filteredList = filteredList.filter((item) => {
        return ((item.permit_id != this.permit.permit_id) && item.handle_method == 'manual')
      });
      this.filtered_permit_list  = filteredList;

      this.flex_permit_onetime = this.permit.recurring == 0 && this.permit.flex_permit == 1 ? true :false;
      this.setSelectedAdditionalProperties();
      this.fetchRequiredCustomIdentifierOptions(this.permit.property_id, true);
    },
   /*  selectAlldays(){
        this.allDays =!this.allDays;
        this.permit.available_days=[];
        if(this.allDays==true){
          for(let i=1;i<8;i++){
              let every_day=i;
              this.permit.available_days.push(every_day);
          }
        }
        else{
            this.permit.available_days=[];
        }
    }, */
    selectAlldays(){
        this.allDays =!this.allDays;
        this.permit.available_days=[];
        if(this.allDays==true){
          for(let i=1;i<8;i++){
              let every_day=i;
              this.permit.available_days.push(every_day);
          }
          this.permitTimesCurrent = this.permit.permitTimes[7];
          this.selectedDay = this.dayOfWeekArr[7];
          this.displayTimeFlag=true;
          console.log(this.permit.available_days);
          console.log(this.allDays);
        }
        else{
              this.permit.available_days=[];
              this.displayTimeFlag=false;

              for(let day_no=1;day_no<=8;day_no++)
              {
                  if(this.permit.permitTimes[day_no-1].length>1){
                  
                      this.permit.permitTimes[day_no-1].forEach((element,index) => {
                          this.$delete(this.permit.permitTimes[day_no-1],index);
                      });
                  }
                  else{
                      this.permit.permitTimes[day_no-1][0].permitStartTime='';
                      this.permit.permitTimes[day_no-1][0].permitEndTime='';

                  }
              }
              console.log(this.permit.available_days);
        }
    },
    didSelectAdditionalProperties(items) {
      this.additionalProperties = items;
      this.permit.property_id_list = items.map(item => item.space_id);

      console.debug(this.permit.property_id_list);
    },
    setSelectedAdditionalProperties() {
      console.debug('setSelectedAdditionalProperties', this.permit.property_id_list);

      this.additionalProperties = this.propertyLists.filter((property) => {
        return this.permit.property_id_list.includes(property.space_id);
      });
    },
    checkNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        }
        return true;
    },  
    checkFloat(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      return true;
    }, 
    checkDurationTime(permitTime){
       
       if(permitTime.permitEndTime!='')
       {      
            if((permitTime.permitStartTime>=permitTime.permitEndTime)|| permitTime.permitStartTime==''){
                this.$toasted.show("start time must be less than end time!", {
                        icon: "times-circle",
                        className: "error-class",
                    });
            }
       }
      
    },
    getCheckedStatus(checked, type) {
      if(type == 'force_delete') {
        this.permit.force_delete = checked;
      }
      if(type == 'notify_users') {
        this.permit.notify_users = checked;
      }
      if(type == 'unlimited_permit') {
        this.permit.unlimited_permit = checked;
        this.permit_quantity_key++;
        if(this.permit.unlimited_permit) {
          this.permit.permit_quantity = 0;
        }
      }
      else if( type == 'full_access') {
        this.permit.full_access = checked;
      }
      else if( type == 'ev_charging') {
        this.permit.ev_charging = checked;
      }
      else if(type == 'handle_method') {
        this.permit.handle_method = checked;
      }
      else if(type == 'freeWeekendPermit') {
        this.permit.free_weekend_permit = checked;
      }
      else if(type == 'onetime'){
          this.flex_permit_onetime = checked;

        // if(this.permit.flex_permit_onetime != "undefined"){
        // }
      }
      else if(type == 'freePermit')
      {
        this.permit.free_permit = checked;
      }
      else if(type == 'activate_permit_timeslot') {
        
          this.permit.activate_permit_timeslot = checked;
          this.test = checked;
          if(this.permit.activate_permit_timeslot==false){
            //alert();
              this.permit.permitTimes = this.getEmptyTimeSlots();
              if (this.selectedDay!=='')
              {
                  let index_no = this.dayOfWeekArr.indexOf(this.selectedDay);
                  this.permitTimesCurrent={};
                  this.permitTimesCurrent=this.permit.permitTimes[index_no];
              }
          
          }
          //alert(this.permit.activate_permit_timeslot);
        } else if (type === 'publicPermit') {
            this.permit.public_permit = checked;
        } else if (type === 'backdate_subscription') {
            this.permit.backdate_subscription = checked;
            this.backdateTemplateError = '';

            if (checked) {
              // Auto-populate template based on current duration type
              const durationTemplates = {
                day: 'Y-m-d 00:00:00',
                week: 'monday this week',
                month: 'Y-m-01 00:00:00',
                year: 'Y-01-01 00:00:00'
              };
              this.permit.backdate_start_date_template = durationTemplates[this.permit.permit_duration_type] || '';
            } else {
              this.permit.backdate_start_date_template = '';
            }
        } else if (type === 'enforce_vehicle_count') {
            this.permit.enforce_vehicle_count = checked;
            this.enforcedVehicleCountError = '';

            if (!checked) {
              this.permit.enforced_vehicle_count = null;
            } else if (!this.permit.enforced_vehicle_count || this.permit.enforced_vehicle_count < 1) {
              this.permit.enforced_vehicle_count = 1;
            }
        }
      // console.log(this.permit.flex_permit_onetime);
    },
    /* availableDays(day) {
        if(this.permit.available_days.indexOf(day)== -1) {
            this.permit.available_days.push(day);
            if(this.available_days.length == 7){
                this.allDays=true;
            }
        }
        else {
            let index = this.permit.available_days.indexOf(day);
            this.$delete(this.permit.available_days,index);
            this.allDays =false;
        }
    }, */
     availableDays(day) {
        if(this.permit.available_days.indexOf(day)== -1) {
            this.permit.available_days.push(day);
            if(this.permit.available_days.length == 7){
                this.allDays=true;
                let day_no = 8;
                if(this.permit.permitTimes[day_no-1].length>1){
                
                    this.permit.permitTimes[day_no-1].forEach((element,index) => {
                        this.$delete(this.permit.permitTimes[day_no-1],index);
                    });
                }
                else{
                    this.permit.permitTimes[day_no-1][0].permitStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitEndTime='';

                }
                
            }
            this.permitTimesCurrent = this.permit.permitTimes[day-1];
            this.selectedDay = this.dayOfWeekArr[day-1];
            this.displayTimeFlag=true;
        }
        else {
            let index = this.permit.available_days.indexOf(day);
            this.$delete(this.permit.available_days,index);
            this.allDays =false;
           
            if(this.permit.permitTimes[day-1].length>1){
              
                this.permit.permitTimes[day-1].forEach((element,index) => {
                    this.$delete(this.permit.permitTimes[day-1],index);
                });
            }
            else{
                this.permit.permitTimes[day-1][0].permitStartTime='';
                this.permit.permitTimes[day-1][0].permitEndTime='';

            }
            
            this.permitTimesCurrent = this.permit.permitTimes[day-1];
            this.selectedDay = '';
            this.displayTimeFlag=false;
        }
    },
    viewDayTimeSlot(day) {
        if((this.permit.available_days.indexOf(day)== -1 && day!=8)||(this.allDays==false && day==8)){
            return;
        }
        this.permitTimesCurrent = this.permit.permitTimes[day-1];
        this.permitTimesCurrent.sort(this.compareTime);
        this.selectedDay = this.dayOfWeekArr[day-1];
        this.displayTimeFlag=true;
    },
    compareTime(item1, item2) {
        const timeItem1 = item1.permitFormatedStartTime.split(':').map(Number);
        const timeItem2 = item2.permitFormatedStartTime.split(':').map(Number);

        if (timeItem1[0] < timeItem2[0]) {
            return -1;
        } else if (timeItem1[0] > timeItem2[0]) {
            return 1;
        } else {
            if (timeItem1[1] < timeItem2[1]) {
                return -1;
            } else if (timeItem1[1] > timeItem2[1]) {
                return 1;
            } else {
                return 0;
            }
        }
    },
    /**
     * Add Permit Time
     */
    addPermitTime() {

      this.permitTimesCurrent.push({permitStartTime:'',permitEndTime:''})

      var div = document.getElementById("permit_time_div");
      this.$nextTick(() => {
        div.scrollTop = div.scrollHeight - div.clientHeight;
      });
    },
    /**
     * Remove permit time
     */
    removePermitTime(index) {
      this.$delete(this.permitTimesCurrent, index);
    },
    closeModal() {
      this.resetData();
      this.$modal.hide("edit-permit");
    },
    resetData() {
      this.update_button= {
        disabled: false,
        success: false,
        loading: false
      };
      this.permit= {
        permit_name: '',
        permit_price: 0,
        property_id_list: [],
        unlimited_permit: false,
        permit_quantity: 0,
        recurring: 0,
        date_range: 1,
        start_date: '',
        end_date: '',
        duration: '',
        duration_type: 'month',
        available_days: [],
        permitTimes: this.getEmptyTimeSlots(),
        activate_permit_timeslot:false,
        full_access: false,
        ev_charging: false,
        handle_method: false,
        flex_permit: 0,
        available_parking_days: 1,
        flex_permit_onetime:false,
        enforce_vehicle_count: false,
        enforced_vehicle_count: null,
        backdate_subscription: false,
        backdate_start_date_template: '',
      };
      this.additionalProperties = [];
      this.permit_quantity_key= 1;
      this.selectedDay='';       
      this.permitTimesCurrent= {}; 
      this.displayTimeFlag = false;
      this.permitTimeZone = "";
      this.requiredCustomIdentifierOptions = [];
      this.selectedRequiredCustomIdentifiers = [];
      this.requiredCustomIdentifiersLoading = false;
      this.requiredCustomIdentifiersError = '';
      this.backdateTemplateError = '';
      this.enforcedVehicleCountError = '';
    },
    validateTimeSlot(){

        var flag = true;

        let day_no=8;// all days
        let clone_done = false;
        //first check for the any valid start and end time available or not , if yes then clone the same data for all days
        if(this.allDays==true){

            let flag_blanck = true;
            if(this.permit.permitTimes[day_no-1].length>0) 
            {
            if(this.permit.permitTimes[day_no-1].length>0) 
                    this.permit.permitTimes[day_no-1].forEach((element,index) => {

                    let permitStartTimeNew = this.permit.permitTimes[day_no-1][index].permitStartTime;
                    let permitEndTimeNew = this.permit.permitTimes[day_no-1][index].permitEndTime;
                    if((permitStartTimeNew =='' && permitEndTimeNew !='')|| (permitStartTimeNew != '' && permitEndTimeNew ==''))
                    {
                        this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s Start time must be less than end time!", {
                            icon: "times-circle",
                            className: "error-class",
                        });
                        flag=false;                               
                    }
                    else if(permitStartTimeNew !='' && permitEndTimeNew !=''){

                        if (permitStartTimeNew>=permitEndTimeNew){
                            this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s Start time must be less than end time!", {
                                icon: "times-circle",
                                className: "error-class",
                            });
                            flag=false;
                        }
                    }else if(permitStartTimeNew =='' && permitEndTimeNew ==''){
                        if(this.permit.permitTimes[day_no-1].length>1){
                            this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s start time and end time is not valid!", {
                                icon: "times-circle",
                                className: "error-class",
                            });
                            flag=false;
                        }
                        flag_blanck = false;
                    }
                    if(flag==false)
                    {
                        return;
                    }
                        
                });  
            }

            //copying array
            if(flag==true && flag_blanck==true && this.permit.permitTimes[day_no-1].length>0){
                    for(let day_no_new=1;day_no_new<=7;day_no_new++){
                        let arr_length = this.permit.permitTimes[day_no-1].length;
                        this.permit.permitTimes[day_no_new-1]=[{}];
                        for(let index1=0;index1<arr_length;index1++){
                            this.permit.permitTimes[day_no_new-1][index1].permitStartTime = this.permit.permitTimes[day_no-1][index1].permitStartTime;
                            this.permit.permitTimes[day_no_new-1][index1].permitEndTime = this.permit.permitTimes[day_no-1][index1].permitEndTime;
                            if(index1<arr_length-1){
                                this.permit.permitTimes[day_no_new-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                            }
                            clone_done=true;
                        }
                    }
            }
        } 

        if(clone_done==true){
            return true;
        }

        // convert null data to space for timeslot
       for(let day_no_new=1;day_no_new<=8;day_no_new++){
            let arr_length = this.permit.permitTimes[day_no_new-1].length;
           
            if(arr_length==1){

                if(this.permit.permitTimes[day_no_new-1][arr_length-1].permitStartTime==null){
                  this.permit.permitTimes[day_no_new-1][arr_length-1].permitStartTime = '';
                }
                if(this.permit.permitTimes[day_no_new-1][arr_length-1].permitFormatedStartTime==null){
                  this.permit.permitTimes[day_no_new-1][arr_length-1].permitFormatedStartTime = '';
                }
                if(this.permit.permitTimes[day_no_new-1][arr_length-1].permitEndTime==null){
                  this.permit.permitTimes[day_no_new-1][arr_length-1].permitEndTime = '';
                }
                if(this.permit.permitTimes[day_no_new-1][arr_length-1].permitFormatedEndTime==null){
                  this.permit.permitTimes[day_no_new-1][arr_length-1].permitFormatedEndTime = '';
                }
            }
            // else if(arr_length==1){
            //    this.permit.permitTimes[day_no_new-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
            // }
           
        } 

        for(let day_no=1;day_no<=8;day_no++)
        {             
            if(this.permit.available_days.indexOf(day_no)!=-1 || (day_no==8 && this.allDays==true)) 
            {  
                if(this.permit.permitTimes[day_no-1].length>0) 
                {
                    console.info(day_no-1+"  >>>  "+JSON.stringify(this.permit.permitTimes[day_no-1]));
                    this.permit.permitTimes[day_no-1].forEach((element,index) => {
                        //console.log(">>>>>>>>permitStartTime>>"+this.permitTimes[day_no-1][index].permitStartTime);
                        let permitStartTimeNew = this.permit.permitTimes[day_no-1][index].permitStartTime;
                        let permitEndTimeNew = this.permit.permitTimes[day_no-1][index].permitEndTime;
                        console.info(">>>"+JSON.stringify(this.permit.permitTimes[day_no-1]));
                        if((permitStartTimeNew =='' && permitEndTimeNew !='')|| (permitStartTimeNew != '' && permitEndTimeNew ==''))
                        {                   
                            this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s Start time must be less than end time!", {
                                icon: "times-circle",
                                className: "error-class",
                            });
                            flag=false;                               
                        }
                        else if(permitStartTimeNew !='' && permitEndTimeNew !=''){
                            if (permitStartTimeNew>=permitEndTimeNew){
                                this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s Start time must be less than end time!", {
                                    icon: "times-circle",
                                    className: "error-class",
                                });
                                flag=false;
                            }
                        }
                        if(flag==false)
                        {
                            return;
                        }
                            
                    });      
                }
                else{
                    this.permit.permitTimes[day_no-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                    this.permit.permitTimes[day_no-1][0].permitStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitEndTime='';
                }            
            }
            else{
                if(this.permit.permitTimes[day_no-1].length>0){
                
                    this.permit.permitTimes[day_no-1].forEach((element,index) => {
                        if(index>0)
                        {
                            this.$delete(this.permit.permitTimes[day_no-1],index);
                        }
                    });
                    this.permit.permitTimes[day_no-1][0].permitStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitEndTime='';
                }
                else{
                    this.permit.permitTimes[day_no-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                    this.permit.permitTimes[day_no-1][0].permitStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitEndTime='';

                }
            }
            if(flag==false)
            {
                return flag;
            }
        }
       
        return flag;
    },
    addFormatedTimes(){

        for(let day_no=1;day_no<=8;day_no++)
        {             
            if(this.permit.available_days.indexOf(day_no)!=-1 || (day_no==8 && this.allDays==true)) 
            {  
                if(this.permit.permitTimes[day_no-1].length>0) 
                {
                    this.permit.permitTimes[day_no-1].forEach((element,index) => {
                        let permitStartTimeNew = this.permit.permitTimes[day_no-1][index].permitStartTime;
                        let permitEndTimeNew = this.permit.permitTimes[day_no-1][index].permitEndTime;
                        if(permitStartTimeNew !='' && permitEndTimeNew !=''){
                            this.permit.permitTimes[day_no-1][index].permitFormatedStartTime = this.$moment(permitStartTimeNew).tz(this.permitTimeZone).format("HH:mm");
                            this.permit.permitTimes[day_no-1][index].permitFormatedEndTime = this.$moment(permitEndTimeNew).tz(this.permitTimeZone).format("HH:mm");
                        }
                            
                    });      
                }
                else{
                    this.permit.permitTimes[day_no-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                    this.permit.permitTimes[day_no-1][0].permitStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitFormatedStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitEndTime='';
                    this.permit.permitTimes[day_no-1][0].permitFormatedEndTime='';
                }            
            }
            else{
                if(this.permit.permitTimes[day_no-1].length>0){
                
                    this.permit.permitTimes[day_no-1].forEach((element,index) => {
                        if(index>0)
                        {
                            this.$delete(this.permit.permitTimes[day_no-1],index);
                        }            
                    });
                    this.permit.permitTimes[day_no-1][0].permitStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitFormatedStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitEndTime='';
                    this.permit.permitTimes[day_no-1][0].permitFormatedEndTime='';
                }
                else{
                    this.permit.permitTimes[day_no-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                    this.permit.permitTimes[day_no-1][0].permitStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitFormatedStartTime='';
                    this.permit.permitTimes[day_no-1][0].permitEndTime='';
                    this.permit.permitTimes[day_no-1][0].permitFormatedEndTime='';

                }
            }
        }
    },
    updatePermit() {
      // Validation
      // console.log(this.permit);

      if(this.permit.permit_name.length == 0) {
        this.$toasted.show("Permit Name is required!",{
            icon: 'times-circle',
            className: 'error-class'
        });
        return;
      }
      if(this.permit.permit_name.length > 40) {
        this.$toasted.show("Permit Name can not be more than 40 characters long!",{
            icon: 'times-circle',
            className: 'error-class'
        });
        return;
      }
      let total_duration = this.permit.permit_duration_type == 'day' ? this.permit.permit_duration : (this.permit.permit_duration_type== 'week' ? (this.permit.permit_duration * 7) : (this.permit.permit_duration_type == 'month' ? this.permit.permit_duration * 30 : (this.permit.permit_duration_type =="year" ? this.permit.permit_duration*365 :this.permit.permit_duration)));
      // console.log('total_duration', total_duration);
      // console.log('available days',this.permit.available_parking_days);
      if(this.permit.available_parking_days > total_duration) {
        this.$toasted.show("Number of available parking days can not be more than the permit duration!",{
            icon: 'times-circle',
            className: 'error-class'
        });
        return;
      }  
      if(!window.regularExpressions.specialName.test(this.permit.permit_name)) {
        this.$toasted.show("Please provide a valid permit name!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.permit.permit_price == 0 && this.permit.handle_method === false) {
        this.$toasted.show("Permit price can not be 0 if handled by stripe!",{
            icon: 'times-circle',
            className: 'error-class'
        });
        return;
      }
      if(!this.permit.unlimited_permit && (this.permit.permit_quantity <= 0 || this.permit.permit_quantity == '')) {
        this.$toasted.show("Please provide a valid number of available permits!",{
            icon: 'times-circle',
            className: 'error-class'
        });
        return;
      }
      if (this.permit.enforce_vehicle_count && (!this.permit.enforced_vehicle_count || this.permit.enforced_vehicle_count < 1)) {
        this.enforcedVehicleCountError = 'Allowed vehicles is required and must be at least 1 when enforcement is enabled.';
        this.$toasted.show(this.enforcedVehicleCountError, {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.permit.available_days.length == 0) {
        this.$toasted.show("Please provide days at which the permit will be available!",{
            icon: 'times-circle',
            className: 'error-class'
        });
        return;
      }
      if(this.permit.recurring == 0 && this.permit.start_date !='' && this.permit.end_date!='') {
        let diff = this.$moment(this.permit.end_date).diff(this.permit.start_date,'days');

        if(diff<7) {
          let temp_start = this.permit.start_date;
          let temp_end = this.permit.end_date;
          let day_array = [];
          while(this.$moment(temp_end).diff(temp_start) >= 0) {
            let day_of_week = parseInt(this.$moment(temp_start).format("E"));
            day_array.push(day_of_week);

            temp_start = this.$moment(temp_start).add(1,'days');
          }

          let day_diff = this.permit.available_days.some(val=> day_array.indexOf(val) === -1);

          if(day_diff) {
            this.$toasted.show("Available days are invalid. Please provide vaild available days!",{
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
          }
        }
      }
      
      if(this.permit.activate_permit_timeslot==true)
      {
          let validateTimeCheck = this.validateTimeSlot();
          if(validateTimeCheck==false){
              return;
          }
          this.addFormatedTimes();
      }

      const requiredCustomIdentifierValidation = this.validateRequiredCustomIdentifiers();
      if (!requiredCustomIdentifierValidation.valid) {
        this.$toasted.show(requiredCustomIdentifierValidation.message, {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      const normalizedBackdateStartDateTemplate = this.permit.backdate_start_date_template
        ? String(this.permit.backdate_start_date_template).trim()
        : '';
      if (this.permit.backdate_subscription && !normalizedBackdateStartDateTemplate) {
        this.backdateTemplateError = 'Backdate start date template is required when backdating is required.';
        this.$toasted.show(this.backdateTemplateError, {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      // Validation Ends
      let update_request = {
        permit_id:                      this.permit.permit_id,
        permit_name:                    this.permit.permit_name,
        property_id_list:               this.permit.property_id_list,
        full_access:                    this.permit.full_access ? 1 : 0,
        free_permit:                    this.permit.free_permit == true ? 1 : 0,
        ev_charging:                    this.permit.ev_charging ? 1 : 0,
        flex_permit:                    this.permit.flex_permit,
        permit_price:                   this.permit.permit_price,
        force_delete:                   this.permit.force_delete == true ? 1 : 0,
        notify_users:                   this.permit.notify_users == true ? 1 : 0,
        sub_permit_ids:                 this.subpermit_selected_list.map(el => el.permit_id),
        available_days:                 this.permit.available_days,
        permit_quantity:                this.permit.permit_quantity,
        unlimited_permit:               this.permit.unlimited_permit,
        free_weekend_permit:            this.permit.free_weekend_permit,
        public_permit:                  this.permit.public_permit,
        enforce_vehicle_count:          this.permit.enforce_vehicle_count ? 1 : 0,
        enforced_vehicle_count:         this.permit.enforce_vehicle_count ? parseInt(this.permit.enforced_vehicle_count, 10) : null,
        backdate_subscription:          this.permit.backdate_subscription ? 1 : 0,
        backdate_start_date_template:   this.permit.backdate_subscription ? normalizedBackdateStartDateTemplate : '',
        flex_permit_onetime:            this.flex_permit_onetime,
        available_parking_days:         this.permit.available_parking_days,
        available_days_timeslot:        this.permit.permitTimes,
        available_days_timeslot_status: this.permit.activate_permit_timeslot==true?1:0,
        required_custom_identifiers:    this.getRequiredCustomIdentifiersPayload(),
      }

      if (this.permit.property_id !== this.property_id) {
        update_request['property_id'] = this.permit.property_id;
      }

      this.update_button.disabled = true;
      this.update_button.loading = true;
      this.update_button.success = false;

      this.axios
        .post(window.hostname + "api/auth/permit/update", update_request)
        .then(res=> {
            if(res.data.status) {
                this.$emit("update_list");
                this.$toasted.show(res.data.message,{
                    icon: 'check-circle',
                    className: 'success-class'
                });
                this.closeModal();
            }
            else {
                this.$toasted.show(res.data.message,{
                    icon: 'times-circle',
                    className: 'error-class'
                });
            }

            this.update_button.disabled = false;
            this.update_button.loading = false;
            this.update_button.success = false;
        })
        .catch(err=>{ 
          this.requiredCustomIdentifiersError = extractFieldErrors(err, 'required_custom_identifiers').join(' ');
          this.backdateTemplateError = extractFieldErrors(err, 'backdate_start_date_template').join(' ') || extractFieldErrors(err, 'backdate_subscription').join(' ');
          this.enforcedVehicleCountError = extractFieldErrors(err, 'enforced_vehicle_count').join(' ') || extractFieldErrors(err, 'enforce_vehicle_count').join(' ');
          this.$toasted.show(extractApiErrorMessage(err),{
                icon: 'times-circle',
                className: 'error-class'
            });
            this.update_button.disabled = false;
            this.update_button.loading = false;
            this.update_button.success = false;
        });
    },
    deletePermit() {
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this permit?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/permit/delete", {
              permit_id: this.permit.permit_id,
              force_delete: this.permit.force_delete == true ? 1 : 0,
              notify_users: this.permit.notify_users == true ? 1 : 0,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.$emit("update_list");
                this.closeModal();
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });
    },
  },
};
</script>

<style>
</style>